import { ANALYTIC_SETUP, ANALYTIC_DISMANTLE } from '../actions/analytics';

const defaultState = {
  setUpAnalytics: false,
  analyticsId: null
};

export default function(state = defaultState, action) {
  switch (action.type) {
    case ANALYTIC_SETUP:
      return {
        ...state,
        setUpAnalytics: true,
        analyticsId: action.analyticsId
      };
    case ANALYTIC_DISMANTLE:
      return {
        ...state,
        setUpAnalytics: false,
        analyticsId: null
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/analytics.js